export default function AdBanner() {
  return null;
}